import React, { useState } from "react";
import { InputGroup } from "react-bootstrap";
import CurrencyInput from "react-currency-input-field";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { unitSelector } from "../../redux/unit.slice";
import withAuthProvider from "../../services/withAuthProvider";

const OfferForm = ({ timeBidUnitDetail }) => {
  const [ToggleOffer, setToggleOffer] = useState(false);
  const dataUnit = useSelector(unitSelector);

  const multipleBid = dataUnit?.unit_type?.multiple_bid;
  const basePrice = dataUnit?.base_price;
  const stockUnitId = dataUnit?.id;
  const userOffer = timeBidUnitDetail?.user_bidding_progress.length
    ? timeBidUnitDetail?.user_bidding_progress[0]?.offer_price
    : 0;

  const [offer, setOffer] = useState(basePrice);

  const handleOffer = (val) => {
    const value = parseInt(val);
    setOffer(value);
  };

  const convertRupiah = (number) => {
    if (!number) return "-";

    var number_string = number.toString(),
      split = number_string.split(","),
      sisa = split[0].length % 3,
      rupiah = split[0].substr(0, sisa),
      ribuan = split[0].substr(sisa).match(/\d{3}/gi);

    // tambahkan titik jika yang di input sudah menjadi number ribuan
    if (ribuan) {
      let separator = sisa ? "." : "";
      rupiah += separator + ribuan.join(".");
    }

    rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
    return "Rp. " + rupiah;
  };

  const toastError = (message) => {
    toast.error(message, {
      id: "error-message",
      duration: 3000,
    });
  };

  const handleSimpan = async () => {
    const params = {
      offer: offer,
    };

    let error = "";

    if (!offer) {
      error = "Penawaran tidak boleh kosong";
    } else if (offer % multipleBid !== 0) {
      error = `Penawaran harus kelipatan ${multipleBid.toLocaleString()}`;
    } else if (offer < basePrice) {
      error = `Penawaran harus lebih besar dari penawaran saat ini`;
    }

    if (error.length > 0) {
      toastError(error);
    } else {
      const response = await withAuthProvider.postDataWithAuth(
        `/api/v2/auction/${stockUnitId}/time-bid`,
        params
      );

      if (response) {
        if (response?.status === 200) {
          toast.success("Penawaran telah dikirim", {
            id: "success-message",
            duration: 3000,
          });
          setToggleOffer(false);
        } else {
          toastError(
            response?.data?.errors?.details || "Gagal melakukan penawaran"
          );
        }
      } else {
        toastError(
          response?.data?.errors?.details || "Gagal terhubung ke server"
        );
      }
    }

    // reload after 2 secs to get user offer
    setTimeout(function () {
      window.location.reload();
    }, 2000);
  };

  return (
    <div className="unit-time-bid">
      <div className="left">
        <p>Penawaran Anda</p>
        {ToggleOffer ? (
          <>
            <div className="d-flex">
              <div className="group">
                <div style={{ flex: "1" }}>
                  <InputGroup>
                    <InputGroup.Text id="basic-addon1">Rp</InputGroup.Text>
                    <CurrencyInput
                      id="hargaTawar"
                      name="offer"
                      className="form-control"
                      placeholder="Masukan penawaran"
                      value={offer}
                      groupSeparator=","
                      decimalSeparator="."
                      allowDecimals={false}
                      onValueChange={(value, name) => handleOffer(value)}
                    />
                  </InputGroup>
                  {/* <small className="text-primary">{error}</small> */}
                </div>
              </div>

              <input
                type="button"
                className="form-control font-sm"
                value="-"
                style={{ width: "50px" }}
                onClick={() => {
                  if (offer === 0) return;
                  setOffer(offer - multipleBid);
                }}
              />
              <input
                type="button"
                className="form-control font-sm"
                value="+"
                style={{ width: "50px" }}
                onClick={() => {
                  setOffer(offer + multipleBid);
                }}
              />
            </div>
            <small>Kelipatan Bid : {convertRupiah(multipleBid)}</small>
          </>
        ) : userOffer === 0 ? (
          <h4>Belum Ada Penawaran</h4>
        ) : (
          <h4 className="offer">{convertRupiah(userOffer)}</h4>
        )}
      </div>
      <div className="right">
        {ToggleOffer ? (
          <div
            className="d-flex flex-direction-column"
            style={{
              height: "88px",
              justifyContent: "space-between",
            }}
          >
            <button className="submit" onClick={handleSimpan}>
              Tawar
            </button>
            <button
              className="cancel"
              onClick={() => setToggleOffer(!ToggleOffer)}
            >
              Batal
            </button>
          </div>
        ) : userOffer === 0 ? (
          <>
            <div className="mulai-tawar">Mulai menawar disini</div>
            <button
              className="submit"
              onClick={() => setToggleOffer(!ToggleOffer)}
            >
              Tawar
            </button>
          </>
        ) : (
          <button
            className="change"
            onClick={() => setToggleOffer(!ToggleOffer)}
          >
            Ubah Penawaran
          </button>
        )}
      </div>
    </div>
  );
};

export default OfferForm;
